import styled from "styled-components"

export const Titulo = styled.h2`
    margin-top: 40px;
    margin-bottom: 25px;
    text-align: center;
    color: #EEC1C1;
    font-size: 20px;
`
export const Infos = styled.p`
    margin: 15px 0px 15px 0px;
    font-size: 14px;
    color: #EEC1C1;
`

export const Lista = styled.div`
    text-align: center;
    margin-bottom: 40px;
    color: #EEC1C1;
`